
import { DashboardCollaudi } from "./DashboardCollaudi";
import { DashboardDocument } from "./DashboardDocument";
import { DashboardSvincoli } from "./DashboardSvincoli";

export const DASHBOARD_DOCUMENTS : DashboardDocument[] =
[
  {tipologia:"Tipologia che va lunga", titolo:"titolo Documento",ordine:"12345689",posizione:"30/40",user:"Fornitore"},
  {tipologia:"Tipologia che va lunga", titolo:"titolo",ordine:"12345689",posizione:"30/40",user:"Fornitore"},
  {tipologia:"Tipologia che va lunga", titolo:"titolo",ordine:"12345689",posizione:"30/40",user:"Fornitore"},
  {tipologia:"Tipologia che va lunga", titolo:"titolo",ordine:"12345689",posizione:"30/40",user:"Fornitore"},
  {tipologia:"Tipologia che va lunga", titolo:"titolo",ordine:"12345689",posizione:"30/40",user:"Fornitore"},
  {tipologia:"Tipologia che va lunga", titolo:"titolo",ordine:"12345689",posizione:"30/40",user:"Fornitore"},

]

export const DASHBOARD_COLLAUDI : DashboardCollaudi[] =
[
  {data:new Date("2019-01-16"), cliente:"Sala spa234567",fase:"vernicaitura",user1:"GF",user2:"MJ"},
  {data:new Date("2019-01-16"), cliente:"Sala spa",fase:"vernicaitura",user1:"GF",user2:"MJ"},
  {data:new Date("2019-01-16"), cliente:"Sala spa",fase:"vernicaitura lunga ",user1:"GF",user2:"MJ"},
  {data:new Date("2019-01-16"), cliente:"Sala spa",fase:"vernicaitura",user1:"GF",user2:"MJ"},
  {data:new Date("2019-01-16"), cliente:"Sala spa",fase:"vernicaitura",user1:"GF",user2:"MJ"},
]


/*export const DASHBOARD_ORDINI : Ordine[] =
[
  {numeroOrdine:"123456", fornitore: "accenture",  data:new Date("2019-01-16"), stato: "nuovo"},
  {numeroOrdine:"123456", fornitore: "accenture", posizione:"9/20", data:new Date("2019-01-16"), stato: "nuovo"},
  {numeroOrdine:"1234563432343", fornitore: "accenture", posizione:"3/20", data:new Date("2019-01-16"), stato: "nuovo"},
  {numeroOrdine:"123456", fornitore: "accenture", posizione:"1/20", data:new Date("2019-01-16"), stato: "nuovo"},
  {numeroOrdine:"123456", fornitore: "accentureeeeeeeeeeeee", posizione:"19/20", data:new Date("2019-01-16"), stato: "nuovo"},
]
*/
export const DASHBOARD_SVINCOLI : DashboardSvincoli[] =
[
  {numeroOrdine:"123456", posizione:"10/20", descrizione: "Descrizione", fornitore: "Fornitore", daSvincolare: 75, totaleSvincoli: '100 pz', dataApprovazione:new Date("2019-01-16"), stato: "nuovo"},
  {numeroOrdine:"123456", posizione:"9/20", descrizione: "Descrizione", fornitore: "Fornitore", daSvincolare: 75, totaleSvincoli: '100 pz', dataApprovazione:new Date("2019-01-16"), stato: "preapprovato"},
  {numeroOrdine:"1234563432343", posizione:"3/20", descrizione: "Descrizione", fornitore: "Fornitore", daSvincolare: 75, totaleSvincoli: '100 pz', dataApprovazione:new Date("2019-01-16"), stato: "errore"},
  {numeroOrdine:"123456", posizione:"1/20", descrizione: "Descrizione", fornitore: "Fornitore", daSvincolare: 75, totaleSvincoli: '100 pz', dataApprovazione:new Date("2019-01-16"), stato: "approvato"},
  {numeroOrdine:"123456", posizione:"19/20", descrizione: "Descrizione", fornitore: "Fornitore", daSvincolare: 75, totaleSvincoli: '100 pz', dataApprovazione:new Date("2019-01-16"), stato: "nuovo"}
]